





















































import IconItemCategory from "@/common/components/icons/IconItemCategory.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import IconPoint from "@/common/components/icons/IconPoint.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import vuescroll from "vue-scrollto";

@Component({
  components: {
    IconItemCategory,
    IconBase,
    IconArrowBottom,
    IconPoint
  }
})
export default class G01ContentButtonList extends Vue {
  @Prop({ type: Array, required: true, default: () => [] }) categories!: any;
  @Prop({ type: Boolean, required: true, default: true }) isCategory!: boolean;

  get colorCode() {
    return commons?.OrgPageSpecific?.page_color;
  }
  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }

  get isPointRangeFirst() {
    return function(id: any) {
      return id === "item-point-range0";
    };
  }
  get isPointRangeLast() {
    return function(id: any) {
      return id === "item-point-range5";
    };
  }

  onClick(event: any, id: any) {
    const divId = "ex-" + id;
    const div = document.getElementById(divId);
    console.log(event);
    if (div == null) {
      const btn = document.getElementById("btn_" + id);
      btn ? (btn.style.backgroundColor = "#ddd6d6") : "";
    } else {
      const buttons: any = document.getElementsByClassName(
        "p-g01-content-button-list__item__link"
      );
      const buttonCount = buttons.length;

      for (let i = 0; i < buttonCount; i++) {
        buttons[i].style.backgroundColor = "";
      }
    }
  }
}
